import { Route } from 'react-router-dom';

import TypeC from './Type-C';
import TypeD from './Type-D';
import TypeE from './Type-E';
import TypeG from './Type-G';
import TypeH from './Type-H';

// Pages.
import ZonePage from 'pages/galleria/master-plane/zone-6/ProjectZonePage';

const Index = () => {
  return (
    <>
      <Route exact path={`/galleria/master-plan/zone-6`}>
        <ZonePage />
      </Route>
      <TypeC />
      <TypeD />
      <TypeE />
      <TypeG />
      <TypeH />
    </>
  );
};

export default Index;
